module.exports = {
      id: "Info-usage",
      viewBox: "0 0 16 15",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Info-usage",
      toString: function () {
        return this.url;
      }
    }